import { useGeneralSearchModal } from '@modules/global-search';
// @mui
import { Box, Button, Stack, alpha, styled } from '@mui/material';
// utils
// components
import { memo, useCallback, useEffect } from 'react';
import { KeyCode } from 'src/components/KeyCode';
import { useLocales } from 'src/locales';
import Iconify from '../../../components/iconify';

function Searchbar() {
  const { showGeneralSearch } = useGeneralSearchModal();
  const { translate } = useLocales();

  const handleKeyboardEvent = useCallback(
    (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.code === 'KeyK') {
        event.preventDefault();
        showGeneralSearch();
      }
    },
    [showGeneralSearch],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: Need to run at the beginning
  useEffect(() => {
    document.addEventListener('keydown', handleKeyboardEvent);
    return () => {
      document.removeEventListener('keydown', handleKeyboardEvent);
    };
  }, []);

  return (
    <Stack direction="row" mr={1}>
      <StyledButton
        variant="outlined"
        onClick={() => showGeneralSearch()}
        startIcon={<Iconify icon="tabler:search" />}
        endIcon={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              ml: 2,
            }}
          >
            <KeyCode.CtrlOrCmd />
            <KeyCode>k</KeyCode>
          </Box>
        }
      >
        <span
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          {translate('shared.buttons.search')}
        </span>
      </StyledButton>
    </Stack>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.08),
  color: alpha(theme.palette.primary.contrastText, 0.48),
  fontWeight: 400,
  border: `1px solid ${alpha(theme.palette.common.white, 0.16)}`,
}));

export default memo(Searchbar);
